/** @jsx React.DOM */
var React = require('react/addons')
var remotes = require('../../../helpers/remotes')
var formatters = require('../../../helpers/formatters')
var constants = require('../../../helpers/constants')
var TransactionLink = require('../../../partials/wrt/transaction-link')

var Info = React.createClass({displayName: 'Info',
  getInitialState: function() {
    return {
      info: null,
      error: null,
      loading: false
    }
  },

  fetch: function() {
    this.setState({ loading: true })

    var remote = remotes.nodes

    remote.requestAccountInfo(this.props.account, this.fetched)
  },

  fetched:  function(err, info) {
    if (!this.isMounted()) return

    if (err) {
      this.setState({
        error: formatters.formatRemoteResponseError(err),
        loading: false
      })
      return
    }

    this.setState({
      info: info,
      loading: false
    })
  },

  componentWillMount: function() {
    this.fetch()
  },

  render: function() {
    if (this.state.loading) {
      return React.DOM.p(null, "Loading...")
    }

    if (this.state.error) {
      return React.DOM.div({className: "alert alert-danger"}, this.state.error)
    }

    var data = this.state.info.account_data

    var accName = data.Domain ? formatters.escapeHtml(formatters.hex_to_ascii(data.Domain)) : 'Anonymous';

    return React.DOM.table({className: "table table-bordered table-striped"}, 
      React.DOM.tbody(null, 
        React.DOM.tr(null, 
          React.DOM.th(null, "WRT Balance"), 
          React.DOM.td(null, formatters.formatDrops(data.Balance))
        ), 
        React.DOM.tr(null, 
          React.DOM.th(null, "Account name"), 
          React.DOM.td(null, accName)
        ), 
        React.DOM.tr(null, 
          React.DOM.th(null, "Account sequence"), 
          React.DOM.td(null, data.Sequence)
        ), 
        React.DOM.tr(null, 
          React.DOM.th(null, "Latest transaction"), 
          React.DOM.td(null, TransactionLink({hash: data.PreviousTxnID}))
        ), 
        React.DOM.tr(null, 
          React.DOM.th(null, "Latest ledger seen in"), 
          React.DOM.td(null, data.PreviousTxnLgrSeq, " (", this.state.info.ledger_current_index - data.PreviousTxnLgrSeq, " ledgers ago)")
        ), 
        React.DOM.tr(null, 
          React.DOM.th(null, "Owner count"), 
          React.DOM.td(null, data.OwnerCount)
        )
      )
    )
  }
})

module.exports = Info



//////////////////
// WEBPACK FOOTER
// ./src/routes/wrt/account/info.jsx
// module id = 478
// module chunks = 0